import { __ } from '@wordpress/i18n';

const SearchFormTab = () => {
  return (
    <div className="hvnly--builder--int_api__tab_content_panel">
      <h3>{__('Search Form Builder', 'havenlytics')}</h3>
      <p>{__('Configure the property search form fields and filters.', 'havenlytics')}</p>
      {/* Content for search form builder */}
    </div>
  );
};

export default SearchFormTab;